{
  "safetyDataSheets": "安全数据表和物品信息表",
  "bodyContentParagraph1": "化学产品的安全数据表 (SDS) 以及印刷版和设备等物品的物品信息表 (AIS) 包含特定于国家/地区的法规信息。",
  "bodyContentParagraph2": "尽管其他产品也可以使用 SDS 和 AIS 来提供有关其安全使用和处置的指南，但它们的存在并不意味着该产品像化学品或混合物一样受到管制。",
  "bodyContentParagraph3": "搜索 SDS 或 AIS：",

  "bodyContentList1": "选择报告类别（产品 SDS 或物品信息表）。",
  "bodyContentList2": "选择一个国家/地区 - 语言。注意：并非所有报告都以所有语言提供。",
  "bodyContentList3": "<strong> <b>查找 AIS：</b> </strong> 在适当的搜索字段中输入产品目录/再订购编号（不带空格或连字符）或从产品标签获得的部分/完整产品名称。",
  "bodyContentList4": "<strong> <b>查找 AIS：</b> </strong> 在关键词搜索字段中输入从产品标签获得的部分/完整产品名称。",
  "bodyContentList5": "单击搜索按钮。",

  "reportCategory": "报告类别:",
  "country": "国家/地区:",
  "language": " 语言：",
  "catalogNumber": "目录/重新订购号：",
  "productName": "产品名称/关键字：",
  "search": "搜索",

  "inquiriesSentTo": "如果您搜索了 SDS 但找不到该信息，请查看下面的信息。可将查询发送至<a href='mailto:us-pep@kodak.com'>us-pep@kodak.com</a>",

  "platesAndEquipment": "印版和设备",
  "platesAndEquipmentContent": "柯达印版和柯达设备不需要 SDS，因为在通常情况下，这些产品不会造成人身危险或健康风险。",

  "kodakBrandPartner": "柯达品牌合作伙伴产品",
  "kodakBrandPartnerContent": "您要求提供的信息可能与某家被视为柯达品牌合作伙伴的公司出售的产品有关。在这种情况下，请直接联系我们的柯达品牌合作伙伴获取 SDS 或产品信息。",

  "batteries": "电池",
  "strandEurope": "请联系 Strand Europe，网址 <a href='https://www.kodakbatteries.strandeurope.com' target='_blank' >www.kodakbatteries.strandeurope.com</a>",

  "consumerAndProfessionalPhotographicProducts": "消费者和专业摄影产品及文档扫描仪",
  "kodakAlaris": "请联系 Kodak Alaris，网址<a href='https://www.kodakalaris.com' target='_blank' >www.kodakalaris.com</a>",

  "divestedProducts": "剥离的产品",
  "devistedProductsContent": "您所请求的信息可能是某个产品的信息，该产品已作为资产剥离的一部分出售给另一家公司。在这种情况下，请直接联系该公司获取 SDS 或产品信息。",

  "medicalDentalAndIndustrialXrayProducts": "医疗、牙科和工业 X 射线产品",
  "carestreamHealth": "请拨打电话 1-888-777-2072 联系 Carestream Health, Inc. 或访问<a href='https://www.carestream.com' target='_blank' >www.carestream.com</a>",

  "laboratoryAndResearchChemicals": "实验室和研究化学品",
  "fisherChemicalCompany": "请拨打电话 1-800-766-7000 联系 Fisher Chemical Company 或访问<a href='https://www.fishersci.com' target='_blank' >www.fishersci.com</a>",

  "fibersAndPlastics": "纤维和塑料",
  "eastmanChemicalCompany": "请拨打电话 423-229-2000 联系 Eastman Chemical Company 或访问<a href='https://www.eastman.com' target='_blank' >www.eastman.com</a>",

  "copyright": "版权所有 ©2024，伊士曼柯达 (Eastman Kodak) 公司。保留所有权利。",

  "termsOfUse": "使用条款",
  "privacy": "隐私权",
  "accessibility": "无障碍环境",
  "GridHeaders": {
    "Report Category":"报告类别",
    "Country":"国家",
    "Language":"语言",
    "Document Revision Number":"文件修訂號",
    "CatalogNumber":"货号",
    "Document Name": "文件名稱"
  },
  "HeaderLinks":"https://www.kodak.com/zh",

  "FallbackMessage":"很抱歉给您带来不便。服务目前不可用，请稍后再试。",
  "report_Categories_dropdown": [
    {"CatogeryType":"SDS" ,"displayName": "产品安全数据表" },
    {"CatogeryType":"AIS" ,"displayName":"文章信息表"},
    {"CatogeryType":"DGW","displayName": "危险品 (DG) 工作表"}
  ]
}
